import { createRoot } from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { store } from './setup/store';
import { UIKIT } from './UIKIT';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <IntlProvider locale='en-GB'>
            <HashRouter>
                <Routes>
                    <Route path='/*' element={<UIKIT />} />
                </Routes>
            </HashRouter>
        </IntlProvider>
    </Provider>
);
